module.exports = __webpack_public_path__ + "img/1389eca.jpg";